import { useNavigate } from 'react-router-dom';
import styles from './styles/reportTile.module.css';

interface ReportTileProps {
  reportName: string;
  date: string;
  reportId: string;
  type: 'REPORT' | 'INVENTORIES' | 'CHECKLISTS' | 'TRACKER';
}

export default function ReportTile({
  reportId,
  reportName,
  date,
  type,
}: ReportTileProps) {
  const navigate = useNavigate();

  // Map type -> route segment
  const subroute =
    type === 'REPORT'
      ? 'reports'
      : type === 'INVENTORIES'
        ? 'inventories'
        : type === 'CHECKLISTS'
          ? 'checklists'
          : 'trackers'; // TRACKER

  return (
    <div
      onClick={() => navigate(`/${subroute}/${reportId}`)}
      className={styles.wrapper}
    >
      <p className={styles.title}>{reportName}</p>
      <p className={styles.date}>{date}</p>
    </div>
  );
}
